import React, { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export function VideoLinkCell({ c, onSent }: { c: any; onSent: () => void }) {
  const [link, setLink] = useState(c.meeting_link || "");
  const [busy, setBusy] = useState(false);
  if (c.kind !== "virtual") return <span className="text-xs text-neutral-400">—</span>;
  const send = async () => {
    setBusy(true);
    try { await api.post(`/admin-x/consultations/${c.id}/send-link`, { link: link.trim() }); toast("Link emailed to " + c.email); onSent(); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="min-w-[220px] space-y-1.5" data-testid={`consult-link-${c.id}`}>
      <input value={link} onChange={(e) => setLink(e.target.value)} placeholder="https://zoom.us/j/… or facetime:…" className="w-full border border-neutral-300 px-2 py-1 text-xs outline-none focus:border-neutral-900" data-testid={`consult-link-input-${c.id}`} />
      <div className="flex items-center gap-2">
        <button onClick={send} disabled={busy || !link.trim()} className="bg-neutral-900 text-white px-3 py-1 text-[10px] uppercase tracking-wider disabled:opacity-40" data-testid={`consult-link-send-${c.id}`}>{busy ? "Sending…" : c.link_sent_at ? "Resend link" : "Send link"}</button>
        {c.link_sent_at && <span className="text-[10px] text-green-700" data-testid={`consult-link-sent-${c.id}`}>Sent {new Date(c.link_sent_at).toLocaleDateString("en-AU")}</span>}
      </div>
    </div>
  );
}
